export const COUNTRY_FLAGS: Record<string, string> = {
  // A
  'Afghanistan': 'AF', 'Albania': 'AL', 'Algeria': 'DZ', 'Andorra': 'AD', 'Angola': 'AO',
  'Antigua and Barbuda': 'AG', 'Argentina': 'AR', 'Armenia': 'AM', 'Australia': 'AU', 'Austria': 'AT',
  'Azerbaijan': 'AZ',
  // B
  'Bahamas': 'BS', 'Bahrain': 'BH', 'Bangladesh': 'BD', 'Barbados': 'BB', 'Belarus': 'BY',
  'Belgium': 'BE', 'Belize': 'BZ', 'Benin': 'BJ', 'Bhutan': 'BT', 'Bolivia': 'BO',
  'Bosnia and Herzegovina': 'BA', 'Botswana': 'BW', 'Brazil': 'BR', 'Brunei': 'BN', 'Bulgaria': 'BG',
  'Burkina Faso': 'BF', 'Burundi': 'BI',
  // C
  'Cambodia': 'KH', 'Cameroon': 'CM', 'Canada': 'CA', 'Cape Verde': 'CV',
  'Central African Republic': 'CF', 'Chad': 'TD', 'Chile': 'CL', 'China': 'CN', 'Colombia': 'CO',
  'Comoros': 'KM', 'Congo': 'CG', 'Costa Rica': 'CR', 'Croatia': 'HR', 'Cuba': 'CU',
  'Cyprus': 'CY', 'Czech Republic': 'CZ', 'Czechia': 'CZ',
  // D
  'Democratic Republic of the Congo': 'CD', 'Denmark': 'DK', 'Djibouti': 'DJ', 'Dominica': 'DM',
  'Dominican Republic': 'DO',
  // E
  'East Timor': 'TL', 'Ecuador': 'EC', 'Egypt': 'EG', 'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ', 'Eritrea': 'ER', 'Estonia': 'EE', 'Eswatini': 'SZ', 'Ethiopia': 'ET',
  // F
  'Fiji': 'FJ', 'Finland': 'FI', 'France': 'FR',
  // G
  'Gabon': 'GA', 'Gambia': 'GM', 'Georgia': 'GE', 'Germany': 'DE', 'Ghana': 'GH',
  'Greece': 'GR', 'Grenada': 'GD', 'Guatemala': 'GT', 'Guinea': 'GN', 'Guinea-Bissau': 'GW',
  'Guyana': 'GY',
  // H
  'Haiti': 'HT', 'Honduras': 'HN', 'Hong Kong': 'HK', 'Hungary': 'HU',
  // I
  'Iceland': 'IS', 'India': 'IN', 'Indonesia': 'ID', 'Iran': 'IR', 'Iraq': 'IQ',
  'Ireland': 'IE', 'Israel': 'IL', 'Italy': 'IT', 'Ivory Coast': 'CI',
  // J
  'Jamaica': 'JM', 'Japan': 'JP', 'Jordan': 'JO',
  // K
  'Kazakhstan': 'KZ', 'Kenya': 'KE', 'Kiribati': 'KI', 'Kosovo': 'XK', 'Kuwait': 'KW',
  'Kyrgyzstan': 'KG',
  // L
  'Laos': 'LA', 'Latvia': 'LV', 'Lebanon': 'LB', 'Lesotho': 'LS', 'Liberia': 'LR',
  'Libya': 'LY', 'Liechtenstein': 'LI', 'Lithuania': 'LT', 'Luxembourg': 'LU',
  // M
  'Madagascar': 'MG', 'Malawi': 'MW', 'Malaysia': 'MY', 'Maldives': 'MV', 'Mali': 'ML',
  'Malta': 'MT', 'Marshall Islands': 'MH', 'Mauritania': 'MR', 'Mauritius': 'MU', 'Mexico': 'MX',
  'Micronesia': 'FM', 'Moldova': 'MD', 'Monaco': 'MC', 'Mongolia': 'MN', 'Montenegro': 'ME',
  'Morocco': 'MA', 'Mozambique': 'MZ', 'Myanmar': 'MM',
  // N
  'Namibia': 'NA', 'Nauru': 'NR', 'Nepal': 'NP', 'Netherlands': 'NL', 'The Netherlands': 'NL',
  'New Zealand': 'NZ', 'Nicaragua': 'NI', 'Niger': 'NE', 'Nigeria': 'NG', 'North Korea': 'KP',
  'North Macedonia': 'MK', 'Norway': 'NO',
  // O
  'Oman': 'OM',
  // P
  'Pakistan': 'PK', 'Palau': 'PW', 'Palestine': 'PS', 'Panama': 'PA', 'Papua New Guinea': 'PG',
  'Paraguay': 'PY', 'Peru': 'PE', 'Philippines': 'PH', 'Poland': 'PL', 'Portugal': 'PT',
  // Q
  'Qatar': 'QA',
  // R
  'Romania': 'RO', 'Russia': 'RU', 'Rwanda': 'RW',
  // S
  'Saint Kitts and Nevis': 'KN', 'Saint Lucia': 'LC', 'Saint Vincent and the Grenadines': 'VC',
  'Samoa': 'WS', 'San Marino': 'SM', 'Sao Tome and Principe': 'ST', 'Saudi Arabia': 'SA',
  'Senegal': 'SN', 'Serbia': 'RS', 'Seychelles': 'SC', 'Sierra Leone': 'SL', 'Singapore': 'SG',
  'Slovakia': 'SK', 'Slovenia': 'SI', 'Solomon Islands': 'SB', 'Somalia': 'SO', 'South Africa': 'ZA',
  'South Korea': 'KR', 'South Sudan': 'SS', 'Spain': 'ES', 'Sri Lanka': 'LK', 'Sudan': 'SD',
  'Suriname': 'SR', 'Sweden': 'SE', 'Switzerland': 'CH', 'Syria': 'SY',
  // T
  'Taiwan': 'TW', 'Tajikistan': 'TJ', 'Tanzania': 'TZ', 'Thailand': 'TH', 'Togo': 'TG',
  'Tonga': 'TO', 'Trinidad and Tobago': 'TT', 'Tunisia': 'TN', 'Turkey': 'TR',
  'Turkmenistan': 'TM', 'Tuvalu': 'TV',
  // U
  'Uganda': 'UG', 'Ukraine': 'UA', 'United Arab Emirates': 'AE', 'United Kingdom': 'GB',
  'United States': 'US', 'United States Minor Outlying Islands (the)': 'US',
  'Uruguay': 'UY', 'Uzbekistan': 'UZ',
  // V
  'Vanuatu': 'VU', 'Vatican City': 'VA', 'Venezuela': 'VE', 'Vietnam': 'VN',
  // Y
  'Yemen': 'YE',
  // Z
  'Zambia': 'ZM', 'Zimbabwe': 'ZW',
  // Common alternates
  'USA': 'US', 'UK': 'GB', 'U.S.': 'US', 'U.K.': 'GB', 'UAE': 'AE',
  'Republic of Korea': 'KR', 'Korea': 'KR',
  'Czech': 'CZ', 'Slovak Republic': 'SK',
  'Russian Federation': 'RU', 'Türkiye': 'TR',
  'Côte d\'Ivoire': 'CI', 'Timor-Leste': 'TL',
  'Congo (DRC)': 'CD', 'Congo (Republic)': 'CG',
};

export const COMPANY_DOMAINS: Record<string, string> = {
  // Big tech
  'google': 'google.com', 'alphabet': 'abc.xyz', 'microsoft': 'microsoft.com', 'amazon': 'amazon.com',
  'meta': 'meta.com', 'facebook': 'meta.com', 'apple': 'apple.com', 'netflix': 'netflix.com',
  'nvidia': 'nvidia.com', 'intel': 'intel.com', 'ibm': 'ibm.com', 'oracle': 'oracle.com',
  'salesforce': 'salesforce.com', 'adobe': 'adobe.com', 'sap': 'sap.com', 'cisco': 'cisco.com',
  'vmware': 'vmware.com', 'dell': 'dell.com', 'hp': 'hp.com', 'qualcomm': 'qualcomm.com',
  'broadcom': 'broadcom.com', 'amd': 'amd.com', 'samsung': 'samsung.com', 'sony': 'sony.com',
  // Consumer tech / apps
  'uber': 'uber.com', 'lyft': 'lyft.com', 'airbnb': 'airbnb.com', 'stripe': 'stripe.com',
  'spotify': 'spotify.com', 'tesla': 'tesla.com', 'snap': 'snap.com', 'snapchat': 'snap.com',
  'twitter': 'twitter.com', 'x': 'x.com', 'pinterest': 'pinterest.com', 'reddit': 'reddit.com',
  'tiktok': 'tiktok.com', 'bytedance': 'bytedance.com', 'zoom': 'zoom.us',
  'slack': 'slack.com', 'dropbox': 'dropbox.com', 'doordash': 'doordash.com',
  'instacart': 'instacart.com', 'robinhood': 'robinhood.com', 'coinbase': 'coinbase.com',
  'palantir': 'palantir.com', 'palantir technologies': 'palantir.com',
  'databricks': 'databricks.com', 'snowflake': 'snowflake.com',
  // SaaS / cloud / dev
  'shopify': 'shopify.com', 'twilio': 'twilio.com', 'datadog': 'datadoghq.com',
  'cloudflare': 'cloudflare.com', 'atlassian': 'atlassian.com', 'github': 'github.com',
  'gitlab': 'gitlab.com', 'hashicorp': 'hashicorp.com', 'elastic': 'elastic.co',
  'mongodb': 'mongodb.com', 'confluent': 'confluent.io', 'okta': 'okta.com',
  'servicenow': 'servicenow.com', 'workday': 'workday.com', 'hubspot': 'hubspot.com',
  'zendesk': 'zendesk.com', 'splunk': 'splunk.com', 'figma': 'figma.com',
  'notion': 'notion.so', 'canva': 'canva.com', 'asana': 'asana.com',
  'monday.com': 'monday.com', 'monday': 'monday.com', 'wix': 'wix.com',
  'squarespace': 'squarespace.com', 'vercel': 'vercel.com',
  'linear': 'linear.app', 'retool': 'retool.com',
  // Cybersecurity
  'crowdstrike': 'crowdstrike.com', 'palo alto networks': 'paloaltonetworks.com',
  'check point': 'checkpoint.com', 'check point software technologies': 'checkpoint.com',
  'cyberark': 'cyberark.com', 'varonis': 'varonis.com', 'fortinet': 'fortinet.com',
  'zscaler': 'zscaler.com', 'sentinelone': 'sentinelone.com', 'snyk': 'snyk.io',
  'wiz': 'wiz.io', 'orca security': 'orca.security', 'armis': 'armis.com',
  'cato networks': 'catonetworks.com', 'claroty': 'claroty.com',
  'axonius': 'axonius.com', 'pentera': 'pentera.io', 'hunters': 'hunters.security',
  'torq': 'torq.io', 'ermetic': 'ermetic.com', 'talon cyber security': 'talon-sec.com',
  'perimeter 81': 'perimeter81.com', 'salt security': 'salt.security',
  'island': 'island.io', 'silverfort': 'silverfort.com',
  // Consulting / professional services
  'mckinsey & company': 'mckinsey.com', 'mckinsey': 'mckinsey.com',
  'bain & company': 'bain.com', 'bain': 'bain.com',
  'boston consulting group': 'bcg.com', 'boston consulting group (bcg)': 'bcg.com', 'bcg': 'bcg.com',
  'deloitte': 'deloitte.com', 'pwc': 'pwc.com', 'pricewaterhousecoopers': 'pwc.com',
  'ey': 'ey.com', 'ernst & young': 'ey.com', 'kpmg': 'kpmg.com', 'accenture': 'accenture.com',
  'oliver wyman': 'oliverwyman.com', 'roland berger': 'rolandberger.com',
  'a.t. kearney': 'kearney.com', 'kearney': 'kearney.com',
  'strategy&': 'strategyand.pwc.com', 'booz allen hamilton': 'boozallen.com',
  'l.e.k. consulting': 'lek.com',
  // Finance / banking
  'goldman sachs': 'goldmansachs.com', 'morgan stanley': 'morganstanley.com',
  'jpmorgan': 'jpmorganchase.com', 'jpmorganchase': 'jpmorganchase.com', 'jpmorgan chase': 'jpmorganchase.com',
  'blackstone': 'blackstone.com', 'blackrock': 'blackrock.com', 'citadel': 'citadel.com',
  'two sigma': 'twosigma.com', 'de shaw': 'deshaw.com', 'd.e. shaw': 'deshaw.com',
  'jane street': 'janestreet.com', 'bridgewater': 'bridgewater.com',
  'american express': 'americanexpress.com', 'amex': 'americanexpress.com',
  'citigroup': 'citigroup.com', 'citi': 'citigroup.com', 'citibank': 'citigroup.com',
  'bank of america': 'bankofamerica.com', 'barclays': 'barclays.com',
  'hsbc': 'hsbc.com', 'ubs': 'ubs.com', 'credit suisse': 'credit-suisse.com',
  'deutsche bank': 'db.com', 'bnp paribas': 'bnpparibas.com',
  'lazard': 'lazard.com', 'evercore': 'evercore.com', 'moelis': 'moelis.com',
  'centerview partners': 'centerviewpartners.com', 'guggenheim partners': 'guggenheimpartners.com',
  'td securities': 'tdsecurities.com', 'wells fargo': 'wellsfargo.com',
  'charles schwab': 'schwab.com', 'fidelity': 'fidelity.com',
  'visa': 'visa.com', 'mastercard': 'mastercard.com', 'paypal': 'paypal.com',
  'square': 'squareup.com', 'block': 'block.xyz',
  // VC / PE
  'insight partners': 'insightpartners.com', 'sequoia': 'sequoiacap.com',
  'sequoia capital': 'sequoiacap.com', 'andreessen horowitz': 'a16z.com', 'a16z': 'a16z.com',
  'accel': 'accel.com', 'greylock': 'greylock.com', 'benchmark': 'benchmark.com',
  'lightspeed': 'lsvp.com', 'lightspeed venture partners': 'lsvp.com',
  'index ventures': 'indexventures.com', 'general catalyst': 'generalcatalyst.com',
  'tiger global': 'tigerglobal.com', 'softbank': 'softbank.com',
  'kkr': 'kkr.com', 'carlyle': 'carlyle.com', 'apollo': 'apollo.com',
  'tpg': 'tpg.com', 'warburg pincus': 'warburgpincus.com',
  // Israeli tech
  'aidoc': 'aidoc.com', 'moon active': 'moonactive.com', 'moonactive': 'moonactive.com',
  'fiverr': 'fiverr.com', 'ironsource': 'ironsource.com',
  'playtika': 'playtika.com', 'similarweb': 'similarweb.com',
  'taboola': 'taboola.com', 'outbrain': 'outbrain.com',
  'nice': 'nice.com', 'amdocs': 'amdocs.com', 'mobileye': 'mobileye.com',
  'elbit systems': 'elbitsystems.com', 'rafael': 'rafael.co.il',
  'teva': 'tevapharm.com', 'teva pharmaceutical': 'tevapharm.com',
  'innoviz': 'innoviz.tech', 'innoviz technologies': 'innoviz.tech',
  'gett': 'gett.com', 'lemonade': 'lemonade.com', 'hippo': 'hippo.com',
  'riskified': 'riskified.com', 'fundbox': 'fundbox.com', 'tipalti': 'tipalti.com',
  'papaya global': 'papayaglobal.com', 'deel': 'deel.com', 'hibob': 'hibob.com',
  'rapyd': 'rapyd.net', 'payoneer': 'payoneer.com', 'global-e': 'global-e.com',
  'walkme': 'walkme.com', 'sisense': 'sisense.com', 'lightricks': 'lightricks.com',
  'gong': 'gong.io', 'gong.io': 'gong.io', 'snappy': 'snappy.com',
  'honeybook': 'honeybook.com', 'nso group': 'nsogroup.com',
  'iai': 'iai.co.il', 'israel aerospace industries': 'iai.co.il',
  'reichman university': 'runi.ac.il',
  'birthright israel excel': 'birthrightisraelexcel.org',
  'optimus': 'optimus.com', 'servicetitan': 'servicetitan.com',
  'jfrog': 'jfrog.com', 'myheritage': 'myheritage.com',
  'sapiens': 'sapiens.com', 'cellebrite': 'cellebrite.com',
  'solo.io': 'solo.io', 'transmit security': 'transmitsecurity.com',
  'via': 'ridewithvia.com', 'drivenets': 'drivenets.com',
  'trax': 'traxretail.com', 'bringg': 'bringg.com',
  'aqua security': 'aquasec.com', 'fireblocks': 'fireblocks.com',
  'pagaya': 'pagaya.com', 'redis': 'redis.com',
  // Industrial / traditional
  'general motors': 'gm.com', 'general electric': 'ge.com',
  'johnson & johnson': 'jnj.com', 'procter & gamble': 'pg.com',
  'unilever': 'unilever.com', 'nestle': 'nestle.com',
  'coca-cola': 'coca-cola.com', 'pepsico': 'pepsico.com',
  'walmart': 'walmart.com', 'target': 'target.com',
  'boeing': 'boeing.com', 'lockheed martin': 'lockheedmartin.com',
  'raytheon': 'rtx.com', 'northrop grumman': 'northropgrumman.com',
  'siemens': 'siemens.com', 'exxonmobil': 'exxonmobil.com',
  'walt disney': 'disney.com', 'disney': 'disney.com',
  'nike': 'nike.com', 'adidas': 'adidas.com',
  'pfizer': 'pfizer.com', 'moderna': 'modernatx.com',
  'merck': 'merck.com', 'abbott': 'abbott.com',
  '3m': '3m.com', 'caterpillar': 'caterpillar.com',
  'honeywell': 'honeywell.com', 'ge healthcare': 'gehealthcare.com',
  // Media / entertainment
  'linkedin': 'linkedin.com', 'warner bros': 'warnerbros.com',
  'paramount': 'paramount.com', 'nbc universal': 'nbcuniversal.com',
  'comcast': 'comcast.com', 'viacom': 'viacom.com',
  // Other startups
  'openai': 'openai.com', 'anthropic': 'anthropic.com',
  'cohere': 'cohere.com', 'hugging face': 'huggingface.co',
  'scale ai': 'scale.com', 'anduril': 'anduril.com',
  'plaid': 'plaid.com', 'brex': 'brex.com',
  'gusto': 'gusto.com', 'rippling': 'rippling.com',
  'airtable': 'airtable.com', 'webflow': 'webflow.com',
  'supabase': 'supabase.com',
  'dbt labs': 'getdbt.com', 'fivetran': 'fivetran.com',
  'amplitude': 'amplitude.com', 'segment': 'segment.com',
  'mixpanel': 'mixpanel.com', 'heap': 'heap.io',
  'loom': 'loom.com', 'calendly': 'calendly.com',
  'grammarly': 'grammarly.com', 'duolingo': 'duolingo.com',
};

export const UNI_DOMAINS: Record<string, string> = {
  // Israeli universities
  'reichman university (idc herzliya)': 'runi.ac.il', 'reichman university': 'runi.ac.il',
  'idc herzliya': 'runi.ac.il',
  'tel-aviv university': 'tau.ac.il', 'tel aviv university': 'tau.ac.il',
  'tel-aviv u school of management': 'tau.ac.il',
  'hebrew university of jerusalem': 'huji.ac.il', 'hebrew university': 'huji.ac.il',
  'technion - israel institute of technology': 'technion.ac.il', 'technion': 'technion.ac.il',
  'ben-gurion university of the negev': 'bgu.ac.il', 'ben gurion university': 'bgu.ac.il',
  'ben gurion university of the negev': 'bgu.ac.il',
  'bar-ilan university': 'biu.ac.il', 'bar ilan university': 'biu.ac.il',
  'the open university of israel': 'openu.ac.il', 'open university of israel': 'openu.ac.il',
  'university of haifa': 'haifa.ac.il',
  'weizmann institute of science': 'weizmann.ac.il',
  'ariel university': 'ariel.ac.il',
  'shenkar college': 'shenkar.ac.il',
  'bezalel academy of arts and design': 'bezalel.ac.il',
  'college of management academic studies': 'colman.ac.il',
  'interdisciplinary center herzliya': 'runi.ac.il',
  // Ivy League
  'harvard university': 'harvard.edu', 'harvard': 'harvard.edu',
  'harvard university & radcliffe college': 'harvard.edu',
  'yale university': 'yale.edu', 'yale': 'yale.edu',
  'princeton university': 'princeton.edu', 'princeton': 'princeton.edu',
  'columbia university': 'columbia.edu', 'columbia': 'columbia.edu',
  'university of pennsylvania': 'upenn.edu', 'upenn': 'upenn.edu', 'penn': 'upenn.edu',
  'brown university': 'brown.edu', 'brown': 'brown.edu',
  'dartmouth college': 'dartmouth.edu', 'dartmouth': 'dartmouth.edu',
  'cornell university': 'cornell.edu', 'cornell': 'cornell.edu',
  // Top US universities
  'mit': 'mit.edu', 'massachusetts institute of technology': 'mit.edu',
  'stanford university': 'stanford.edu', 'stanford': 'stanford.edu',
  'university of chicago': 'uchicago.edu',
  'duke university': 'duke.edu', 'duke': 'duke.edu',
  'northwestern university': 'northwestern.edu',
  'vanderbilt university': 'vanderbilt.edu',
  'washington university in st. louis': 'wustl.edu',
  'rice university': 'rice.edu',
  'notre dame': 'nd.edu', 'university of notre dame': 'nd.edu',
  'emory university': 'emory.edu',
  'georgetown university': 'georgetown.edu',
  'carnegie mellon university': 'cmu.edu', 'carnegie mellon': 'cmu.edu',
  'new york university': 'nyu.edu', 'nyu': 'nyu.edu',
  'tufts university': 'tufts.edu',
  'boston university': 'bu.edu',
  'boston college': 'bc.edu',
  'brandeis university': 'brandeis.edu',
  'tulane university': 'tulane.edu',
  'george washington university': 'gwu.edu',
  'american university': 'american.edu',
  'johns hopkins university': 'jhu.edu', 'johns hopkins': 'jhu.edu',
  'caltech': 'caltech.edu', 'california institute of technology': 'caltech.edu',
  'georgia institute of technology': 'gatech.edu', 'georgia tech': 'gatech.edu',
  // UC system
  'university of california, berkeley': 'berkeley.edu', 'uc berkeley': 'berkeley.edu',
  'university of california, los angeles': 'ucla.edu', 'ucla': 'ucla.edu',
  'university of california, san diego': 'ucsd.edu', 'ucsd': 'ucsd.edu',
  'university of california, davis': 'ucdavis.edu',
  'university of california, irvine': 'uci.edu',
  'university of california, santa barbara': 'ucsb.edu',
  'university of california, santa cruz': 'ucsc.edu',
  // Large US public
  'university of michigan - ann arbor': 'umich.edu', 'university of michigan': 'umich.edu',
  'university of virginia': 'virginia.edu',
  'university of texas at austin': 'utexas.edu', 'university of texas - austin': 'utexas.edu',
  'university of southern california': 'usc.edu', 'usc': 'usc.edu',
  'university of florida': 'ufl.edu',
  'university of north carolina - chapel hill': 'unc.edu', 'unc chapel hill': 'unc.edu',
  'university of wisconsin-madison': 'wisc.edu',
  'university of maryland': 'umd.edu',
  'university of illinois': 'illinois.edu', 'university of illinois urbana-champaign': 'illinois.edu',
  'indiana university bloomington': 'indiana.edu', 'indiana university': 'indiana.edu',
  'ohio state university': 'osu.edu',
  'penn state university': 'psu.edu', 'penn state': 'psu.edu',
  'university of minnesota': 'umn.edu',
  'university of washington': 'uw.edu',
  'university of colorado boulder': 'colorado.edu',
  'university of arizona': 'arizona.edu',
  'arizona state university': 'asu.edu',
  'michigan state university': 'msu.edu',
  'purdue university': 'purdue.edu',
  'rutgers university': 'rutgers.edu',
  // UK universities
  'university of oxford': 'ox.ac.uk', 'oxford': 'ox.ac.uk',
  'university of cambridge': 'cam.ac.uk', 'cambridge': 'cam.ac.uk',
  'imperial college london': 'imperial.ac.uk',
  'london school of economics': 'lse.ac.uk', 'lse': 'lse.ac.uk',
  'university college london': 'ucl.ac.uk', 'ucl': 'ucl.ac.uk',
  "king's college london": 'kcl.ac.uk',
  'university of edinburgh': 'ed.ac.uk',
  'university of manchester': 'manchester.ac.uk',
  'university of warwick': 'warwick.ac.uk',
  'university of bristol': 'bristol.ac.uk',
  // European universities
  'eth zurich': 'ethz.ch', 'epfl': 'epfl.ch',
  'sorbonne university': 'sorbonne-universite.fr',
  'technical university of munich': 'tum.de',
  'humboldt university of berlin': 'hu-berlin.de',
  'university of amsterdam': 'uva.nl',
  'leiden university': 'universiteitleiden.nl',
  'karolinska institute': 'ki.se',
  // Canadian universities
  'university of toronto': 'utoronto.ca',
  'mcgill university': 'mcgill.ca', 'mcgill': 'mcgill.ca',
  'university of british columbia': 'ubc.ca', 'ubc': 'ubc.ca',
  'university of waterloo': 'uwaterloo.ca',
  'university of western ontario': 'uwo.ca', "queen's university": 'queensu.ca',
  // Asia-Pacific
  'national university of singapore': 'nus.edu.sg', 'nus': 'nus.edu.sg',
  'university of tokyo': 'u-tokyo.ac.jp',
  'tsinghua university': 'tsinghua.edu.cn',
  'peking university': 'pku.edu.cn',
  'university of hong kong': 'hku.hk',
  'university of melbourne': 'unimelb.edu.au',
  'university of sydney': 'sydney.edu.au',
  'australian national university': 'anu.edu.au',
  // Business schools (standalone references)
  'insead': 'insead.edu',
  'london business school': 'london.edu',
  'wharton': 'wharton.upenn.edu',
  'hbs': 'hbs.edu', 'harvard business school': 'hbs.edu',
  'kellogg': 'kellogg.northwestern.edu',
  'booth': 'chicagobooth.edu',
};

export const CC_TO_ISO: Record<string, string> = {
  '1': 'us', '972': 'il', '44': 'gb', '33': 'fr', '49': 'de', '61': 'au',
  '34': 'es', '55': 'br', '39': 'it', '54': 'ar', '41': 'ch', '27': 'za',
  '52': 'mx', '91': 'in', '86': 'cn', '81': 'jp', '82': 'kr', '31': 'nl',
  '46': 'se', '47': 'no', '48': 'pl', '43': 'at', '32': 'be', '351': 'pt',
  '353': 'ie', '358': 'fi', '420': 'cz', '36': 'hu', '40': 'ro', '380': 'ua',
  '7': 'ru', '90': 'tr', '65': 'sg', '852': 'hk', '971': 'ae', '966': 'sa',
  '20': 'eg', '234': 'ng', '254': 'ke', '63': 'ph', '66': 'th', '60': 'my', '62': 'id',
};

export const INDUSTRY_ICONS: Record<string, string> = {
  'technology': '\uD83D\uDCBB', 'software': '\uD83D\uDCBB', 'internet': '\uD83C\uDF10',
  'cybersecurity': '\uD83D\uDD12', 'fintech': '\uD83D\uDCB3',
  'financial': '\uD83D\uDCB0', 'banking': '\uD83C\uDFE6', 'venture capital': '\uD83D\uDCC8',
  'investment': '\uD83D\uDCC8', 'consulting': '\uD83D\uDCCA',
  'healthcare': '\uD83C\uDFE5', 'medical': '\uD83C\uDFE5', 'pharmaceutical': '\uD83D\uDC8A',
  'biotechnology': '\uD83E\uDDEC',
  'education': '\uD83C\uDF93', 'higher education': '\uD83C\uDF93',
  'defense': '\uD83D\uDEE1\uFE0F', 'armed forces': '\uD83C\uDF96\uFE0F', 'military': '\uD83C\uDF96\uFE0F',
  'real estate': '\uD83C\uDFE2', 'retail': '\uD83D\uDED2', 'e-commerce': '\uD83D\uDED2',
  'media': '\uD83D\uDCFA', 'entertainment': '\uD83C\uDFAC',
  'marketing': '\uD83D\uDCE3', 'advertising': '\uD83D\uDCE3',
  'legal': '\u2696\uFE0F', 'law': '\u2696\uFE0F', 'energy': '\u26A1',
  'manufacturing': '\uD83C\uDFED', 'automotive': '\uD83D\uDE97',
  'food': '\uD83C\uDF7D\uFE0F', 'travel': '\u2708\uFE0F', 'hospitality': '\uD83C\uDFE8',
  'nonprofit': '\uD83E\uDD1D', 'government': '\uD83C\uDFDB\uFE0F',
  'insurance': '\uD83D\uDEE1\uFE0F', 'telecom': '\uD83D\uDCE1', 'logistics': '\uD83D\uDE9A',
  'agriculture': '\uD83C\uDF3E', 'construction': '\uD83C\uDFD7\uFE0F', 'design': '\uD83C\uDFA8',
  'research': '\uD83D\uDD2C', 'ai': '\uD83E\uDD16', 'artificial intelligence': '\uD83E\uDD16',
  'machine learning': '\uD83E\uDD16', 'crypto': '\uD83E\uDE99', 'blockchain': '\uD83E\uDE99',
};

export const AMBIGUOUS_NAMES = new Set([
  'tal', 'noe', 'noam', 'lior', 'adi', 'or', 'gal', 'chen', 'shir', 'mor',
  'eden', 'agam', 'amit', 'rotem', 'shai', 'shay', 'lee', 'liat', 'lia',
  'avery', 'jordan', 'alex', 'sam', 'taylor', 'robin', 'jamie', 'casey', 'riley',
  'ariel', 'dani', 'idan', 'yuval', 'ofer', 'ofir', 'tomer', 'yarden', 'maayan',
  'inbar', 'keren', 'nir', 'ran', 'roni', 'oren', 'anat', 'sapir', 'stav',
  'naomi', 'ari', 'noga', 'bar', 'paz', 'ray', 'reese', 'sage', 'skyler', 'drew',
  'finley', 'hayden', 'harley', 'emery', 'rowan', 'quinn', 'peyton', 'parker',
  'michal', 'ayelet', 'liron', 'snir', 'carmel', 'ella', 'ori', 'shachar', 'yam',
  'angel', 'kim', 'pat', 'terry', 'gene', 'lou', 'frankie', 'nikita', 'andrea',
  'sacha', 'sasha', 'jesse', 'carey', 'leslie', 'lynn', 'kelly', 'tracy', 'sandy',
]);
